import { render } from "./modalLoginAd.vue?vue&type=template&id=beb44fec&scoped=true"
import script from "./modalLoginAd.vue?vue&type=script&lang=js"
export * from "./modalLoginAd.vue?vue&type=script&lang=js"

import "./modalLoginAd.vue?vue&type=style&index=0&id=beb44fec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-beb44fec"

export default script